<template>
  <div>
    <Top />
    <div class="container container--mobile">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <br />
          <div class="margin-top-75"></div>
          <div class="card bg-light">
            <div class="header-wrapper">
              <h1 class="text-danger left-header" v-html="data.optout.wrongInviteHeader"></h1>
            </div>
            <div class="clearfix"></div>
            <p v-html="data.optout.wrongInviteText"></p>
          </div>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <div class="clearfix"></div>
          <button class="btn btn-outline-dark btn-lg btn-block" @click="$router.go(-1)">&#8592; Tillbaka</button>
          <div class="clearfix"></div>
          <button class="btn btn-primary btn-lg btn-block" @click="$router.push('/')">Till startsidan</button>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Top from '../../src/components/Top'
import Bottom from '../../src/components/Bottom'
import { request } from '../plugins/datocms'

export default {
  name: 'errorinvite',
  data () {
    return {
      data: null
    }
  },
  components: {
    Top,
    Bottom
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          optout {
            wrongInviteHeader
            wrongInviteText
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  margin-bottom: 10vh;
  min-height: 60vh;
}
.card {
  padding: 50px;
}
.margin-top-75 {
  margin-top: 75px;
}
.header-wrapper {
  display: flex;
}
.left-header {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/ErrorInvite.vue